import * as DesktopFiltersGoogleAnalytics from '../../_modules/google_analytics/catalog/desktop_filters';
import { updateFiltersAction } from '../../_flux/actions/catalog_filter_actions';
import { showSectionContentsAction, hideSectionContentsAction } from '../../_flux/actions/catalog_filter_view_actions';
import { applyFilters } from '../../_flux/helper/apply_filters';
import { getDefaultValueForFilters } from '../../_flux/helper/filters/get_default_value_for_filters';
import { getFiltersByFilterSection } from '../../_flux/helper/filters/get_filters_by_filter_section';
import { getAbsoluteValueForSpeedIndex } from '../../_modules/tyre_index/get_absolute_value_for_speed_index';
import { Filters } from '../../_flux/constants/filter/filters';
import { requestSetConfiguratorSource } from '../../_modules/requests/request_set_configurator_source';
import {
    showConfirmationLayerAction,
    showAction as showRegoLookupAction,
    showConfirmButtonAction,
} from '../../_flux/actions/rego_lookup_actions';
import { showAction as showVehicleSelectorAction } from '../../_flux/actions/vehicle_configurator_actions';

export const onFilterChange = (currencyIsoCode, productType) => (value, filterName, props) => {
    DesktopFiltersGoogleAnalytics.changeFilter(filterName, value, currencyIsoCode, props);
    updateFiltersAction({ [filterName]: value }).then(() => resetConfiguratorSource(filterName)).then(() => applyFilters(productType));
};

export const onVehicleTyreFilterChange = productType => value => {
    let tyreSize = value.split('|');
    let filters = {
        [Filters.WIDTH]: tyreSize[0],
        [Filters.HEIGHT]: tyreSize[1],
        [Filters.DIAMETER]: tyreSize[2],
        [Filters.POSTCODE]: '',
    };

    if (tyreSize[4] && tyreSize[4].length > 0 && tyreSize[4] !== 'undefined') {
        filters[Filters.LOAD_INDEX] = parseInt(tyreSize[4]);
    }

    let speedIndexAbsValue = getAbsoluteValueForSpeedIndex(tyreSize[5]);
    if (Number.isInteger(speedIndexAbsValue) && speedIndexAbsValue > 0) {
        filters[Filters.SPEED_INDEX] = speedIndexAbsValue;
    }

    updateFiltersAction(filters);
    applyFilters(productType);
};

export function onRegoLookupEdit() {
    showConfirmationLayerAction();
    showConfirmButtonAction();
    showRegoLookupAction();
}

export function onVehicleSelectorEdit() {
    showVehicleSelectorAction();
}

export const onActionClick = productType => (actionToPerform, sectionName) => {
    switch (actionToPerform) {
        case 'open':
            DesktopFiltersGoogleAnalytics.showSectionContents(sectionName);
            showSectionContentsAction(sectionName);
            break;

        case 'close':
            DesktopFiltersGoogleAnalytics.hideSectionContents(sectionName);
            hideSectionContentsAction(sectionName);
            break;

        case 'reset':
            DesktopFiltersGoogleAnalytics.resetSectionContents(sectionName);
            resetFilters(sectionName, productType);
            break;
    }
};

function resetConfiguratorSource(filterName) {
    if (Filters.SPEED_INDEX === filterName || Filters.LOAD_INDEX === filterName) {
        requestSetConfiguratorSource('none')
            .done()
            .catch();
    }
}

function resetFilters(sectionName, productType) {
    const filterToUpdate = getDefaultValueForFilters(getFiltersByFilterSection(sectionName));

    hideSectionContentsAction(sectionName);
    updateFiltersAction(filterToUpdate);
    applyFilters(productType);
}